import { styled } from '@mui/material';

export const Root = styled('div', {
  shouldForwardProp: (prop) => prop !== 'disablePadding',
})<{ disablePadding?: boolean }>(({ theme, disablePadding }) => ({
  display: 'flex',
  alignItems: 'center',
  ...(disablePadding
    ? undefined
    : {
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(2),
      }),
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  flexWrap: 'wrap',
  height: 40,
  color: theme.palette.text.secondary,
}));

export const Left = styled('div')({
  display: 'flex',
  height: 40,
  alignItems: 'center',
  minWidth: 0,
  flex: '1 1 0',
  overflow: 'hidden',
});

export const Center = styled('div')({
  flex: '1 100000 auto',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  overflow: 'hidden',
});

export const Right = styled('div')(({ theme }) => ({
  flex: '0 0 0%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  '& > *': {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));
